import React, { useEffect, useRef, useState } from 'react'
import { Groupper, Header, Stat } from 'react-frontier2'
import { useParams } from 'react-router-dom';
import { PdvStats } from '../../AdminClasses';
import { ErrorHeader, NotFound } from '../../components';
import { addCommas } from '@arema/components/Util'
import { useTitle } from '@arema/components/Hooks';
import { useTranslation } from 'react-i18next';
import PdvCortesList, { CorteListElement } from './PdvConciliaCorteList';
import PdvDepositsList from './PdvConciliaDepositsList';
import API from '../../API';

interface PdvConciliaDetailProps{
	pdv_id?: number,
}

var PdvConciliaDetail = (props: PdvConciliaDetailProps)=>{
	var { t } = useTranslation();
	var { setTitle } = useTitle();
	var params = useParams();
	var [pdv, setPdv] = useState<PdvStats>();
	var [loadError, setLoadError] = useState<string>();
	var corteListRef = useRef<CorteListElement>(null);
	var pdv_id = params.pdv_id || props.pdv_id;
	
	useEffect(() => {
		loadData();
	}, [])
	
	var refreshPage = ()=>{
		loadData();
		if(corteListRef.current) corteListRef.current.reload();
	}
	
	var loadData = ()=>{
		if(Number.isNaN(parseInt(pdv_id as any))) return;
		API.getPdvStats(parseInt(pdv_id as any)).then(res=>{
			if(res.error) setLoadError(res.message);
			setTitle(`Conciliación: ${res.data.pdv_name}`);
			setPdv(res.data);
		}).catch(() => {
			setLoadError('Error inesperado (LCL-1)');
		})
	}
	
	if(Number.isNaN(parseInt(pdv_id as any))) return <NotFound />
	if(loadError){
		return <ErrorHeader error={loadError} />
	}
	if(!pdv){
		return <Header loading text='Cargando pdv' />
	}
	
	return <>
		<Groupper
			title={pdv.pdv_name}
			style={{ maxWidth: 400, marginBottom: 15 }}
		>
			<Stat style={{ padding: 0 }} label={'Faltante'} value={`$${addCommas(pdv.total_cash-pdv.deposit)}`} />
		</Groupper>
		<PdvDepositsList pdv_id={parseInt(pdv_id as any)} onDepositsChange={refreshPage} />
		<PdvCortesList pdv_id={parseInt(pdv_id as any)} ref={corteListRef} />
	</>
}

export default PdvConciliaDetail;